let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hbykq")).then(() => parcelRequire('7SFiN'));